import { useEffect, useRef, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../../app/hooks'
import { restoreSegmentation } from '../../../redux/reducers/segmentation/segmentationFeature'
import { getUserInitialCompletion } from '../../../redux/thunks/user/user'
import { parseSegmentationPreselection } from './segmentationPreselection'
import { SEGMENTATION_HISTORY_STATE_KEY } from './segmentationHistory'

export const useSegmentationInitialization = () => {
  const dispatch = useAppDispatch()
  const { ssoId, isProfessional } = useAppSelector((state) => state.userFeature)
  const selection = useAppSelector((state) => state.segmentationFeature)
  const [preset] = useState(() => parseSegmentationPreselection(window.location.search))
  const [accountLookupSettled, setAccountLookupSettled] = useState(false)
  const request = useRef<Promise<boolean> | undefined>(undefined)

  const [isEntryUntouched] = useState(
    () =>
      !window.history.state?.[SEGMENTATION_HISTORY_STATE_KEY] &&
      !selection.selectedIdentity &&
      !selection.selectedIntent &&
      selection.selectedPropertyTypes.length === 0 &&
      !selection.isShortTermAccommodation &&
      !selection.showBusinessCategories
  )
  const preselectionHandled = useRef(false)

  useEffect(() => {
    if (ssoId) {
      return
    }

    let active = true
    request.current ??= getUserInitialCompletion({ redirectOnUnauthorized: false })(dispatch)
    void request.current.then(() => {
      if (active && preset && isEntryUntouched && !preselectionHandled.current) {
        setAccountLookupSettled(true)
      }
      return undefined
    })
    return () => {
      active = false
    }
  }, [dispatch, isEntryUntouched, preset, ssoId])

  useEffect(() => {
    if (!preset || !isEntryUntouched || preselectionHandled.current || (!ssoId && !accountLookupSettled)) {
      return
    }

    preselectionHandled.current = true
    if (!isProfessional) {
      dispatch(restoreSegmentation(preset))
    }
  }, [accountLookupSettled, dispatch, isEntryUntouched, isProfessional, preset, ssoId])

  const skipParamPreselection = () => {
    preselectionHandled.current = true
  }

  return { skipParamPreselection }
}
